// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/team_email.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.TeamEmail
 */
export const TeamEmail = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TeamEmail",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "imap_server", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "visibility", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "allowed_domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "allow_org_members", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
    { no: 12, name: "stalwart_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateTeamEmailRequest
 */
export const CreateTeamEmailRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateTeamEmailRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "visibility", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "allowed_domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.PauseTeamEmailRequest
 */
export const PauseTeamEmailRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PauseTeamEmailRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ResumeTeamEmailRequest
 */
export const ResumeTeamEmailRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ResumeTeamEmailRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteTeamEmailRequest
 */
export const DeleteTeamEmailRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteTeamEmailRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListTeamEmailsRequest
 */
export const ListTeamEmailsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTeamEmailsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListTeamEmailsResponse
 */
export const ListTeamEmailsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListTeamEmailsResponse",
  () => [
    { no: 1, name: "team_emails", kind: "message", T: TeamEmail, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.GetTeamEmailRequest
 */
export const GetTeamEmailRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTeamEmailRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PreviewTeamEmailRequest
 */
export const PreviewTeamEmailRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PreviewTeamEmailRequest",
  () => [
    { no: 1, name: "local_part", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PreviewTeamEmailResponse
 */
export const PreviewTeamEmailResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PreviewTeamEmailResponse",
  () => [
    { no: 1, name: "full_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.GetTeamEmailDomainRequest
 */
export const GetTeamEmailDomainRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTeamEmailDomainRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetTeamEmailDomainResponse
 */
export const GetTeamEmailDomainResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTeamEmailDomainResponse",
  () => [
    { no: 1, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

